const isEmpty = (value: any) =>
  value === undefined ||
  value === null ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);
  
const isEmailValid = (value: string):boolean => (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !== null);

const formatPhoneNumber = (value:any) => {
  if(!value) return value;
  const phoneNumber = value.replace(/[^\d]/g,'');
  const phoneNumberLength = phoneNumber.length;
  if(phoneNumberLength<4) return phoneNumber;
  if(phoneNumberLength<7){
    return `(${phoneNumber.slice(0,3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0,3)}) ${phoneNumber.slice(3,6)}-${phoneNumber.slice(6,10)}`;
}
const formatMobileNumber = (value:any) => {
  if(!value) return value;
  const phoneNumber = value.replace(/[^\d]/g,'');
  const phoneNumberLength = phoneNumber.length;
  if(phoneNumberLength<4) return phoneNumber;
  if(phoneNumberLength<7){
    return `${phoneNumber.slice(0,3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0,3)}-${phoneNumber.slice(3,6)}-${phoneNumber.slice(6,10)}`;
}

const isPasswordValid = (value: any) => (value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/) !== null);


export {
    isEmpty,
    isEmailValid,
    formatPhoneNumber,
    formatMobileNumber,
    isPasswordValid,
};